export const collections = {
  "leaderboardDocs": {
    "name": "leaderboardDocs",
    "pascalName": "LeaderboardDocs",
    "tableName": "_content_leaderboardDocs",
    "source": [
      {
        "_resolved": true,
        "prefix": "/",
        "include": "**/*",
        "cwd": "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/content"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "updatedAt": "string"
    },
    "schema": {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$ref": "#/definitions/__SCHEMA__",
      "definitions": {
        "leaderboardDocs": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": {}
                }
              ],
              "default": {}
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string",
                      "$content": {
                        "editor": {
                          "input": "icon"
                        }
                      }
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            },
            "updatedAt": {
              "type": "string"
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "description",
            "body"
          ],
          "additionalProperties": false
        }
      }
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_leaderboardDocs (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"body\" TEXT, \"description\" VARCHAR, \"extension\" VARCHAR, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"path\" VARCHAR, \"seo\" TEXT DEFAULT '{}', \"stem\" VARCHAR, \"updatedAt\" VARCHAR NULL, \"__hash__\" TEXT UNIQUE);"
  },
  "testimonials": {
    "name": "testimonials",
    "pascalName": "Testimonials",
    "tableName": "_content_testimonials",
    "source": [
      {
        "_resolved": true,
        "prefix": "/",
        "include": "**/*.yml",
        "cwd": "/app/libs/nuxt-forgd-layer-core/layers/auth/content/testimonials"
      }
    ],
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "avatar": "string",
      "company": "string",
      "companyLogo": "string",
      "enabled": "boolean",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "order": "number",
      "quote": "string",
      "stem": "string"
    },
    "schema": {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$ref": "#/definitions/__SCHEMA__",
      "definitions": {
        "testimonials": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "quote": {
              "type": "string"
            },
            "name": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "company": {
              "type": "string"
            },
            "avatar": {
              "type": "string"
            },
            "companyLogo": {
              "type": "string"
            },
            "order": {
              "type": "number"
            },
            "enabled": {
              "type": "boolean"
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "quote",
            "name",
            "title",
            "company"
          ],
          "additionalProperties": false
        }
      }
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_testimonials (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"avatar\" VARCHAR NULL, \"company\" VARCHAR, \"companyLogo\" VARCHAR NULL, \"enabled\" BOOLEAN NULL, \"extension\" VARCHAR, \"meta\" TEXT, \"name\" VARCHAR, \"order\" INT NULL, \"quote\" VARCHAR, \"stem\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  },
  "pages": {
    "name": "pages",
    "pascalName": "Pages",
    "tableName": "_content_pages",
    "source": [
      {
        "_resolved": true,
        "prefix": "/",
        "include": "**/*",
        "cwd": "/app/libs/nuxt-forgd-layer-core/layers/academy/content/pages"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "draft": "boolean",
      "extension": "string",
      "headline": "string",
      "heroImage": "string",
      "icon": "string",
      "introduction": "boolean",
      "meta": "json",
      "navigation": "json",
      "ogImage": "string",
      "order": "number",
      "path": "string",
      "publishedAt": "string",
      "seo": "json",
      "stem": "string",
      "updatedAt": "string",
      "wistiaId": "string"
    },
    "schema": {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$ref": "#/definitions/__SCHEMA__",
      "definitions": {
        "pages": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": {}
                }
              ],
              "default": {}
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string",
                      "$content": {
                        "editor": {
                          "input": "icon"
                        }
                      }
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            },
            "introduction": {
              "type": "boolean"
            },
            "headline": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            },
            "order": {
              "type": "number"
            },
            "wistiaId": {
              "type": "string"
            },
            "ogImage": {
              "type": "string"
            },
            "heroImage": {
              "type": "string"
            },
            "publishedAt": {
              "type": "string"
            },
            "updatedAt": {
              "type": "string"
            },
            "draft": {
              "type": "boolean"
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "description",
            "body"
          ],
          "additionalProperties": false
        }
      }
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_pages (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"body\" TEXT, \"description\" VARCHAR, \"draft\" BOOLEAN NULL, \"extension\" VARCHAR, \"headline\" VARCHAR NULL, \"heroImage\" VARCHAR NULL, \"icon\" VARCHAR NULL, \"introduction\" BOOLEAN NULL, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"ogImage\" VARCHAR NULL, \"order\" INT NULL, \"path\" VARCHAR, \"publishedAt\" VARCHAR NULL, \"seo\" TEXT DEFAULT '{}', \"stem\" VARCHAR, \"updatedAt\" VARCHAR NULL, \"wistiaId\" VARCHAR NULL, \"__hash__\" TEXT UNIQUE);"
  },
  "snippets": {
    "name": "snippets",
    "pascalName": "Snippets",
    "tableName": "_content_snippets",
    "source": [
      {
        "_resolved": true,
        "prefix": "/",
        "include": "**/*",
        "cwd": "/app/libs/nuxt-forgd-layer-core/layers/academy/content/snippets"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    },
    "schema": {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$ref": "#/definitions/__SCHEMA__",
      "definitions": {
        "snippets": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": {}
                }
              ],
              "default": {}
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string",
                      "$content": {
                        "editor": {
                          "input": "icon"
                        }
                      }
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "description",
            "body"
          ],
          "additionalProperties": false
        }
      }
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_snippets (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"body\" TEXT, \"description\" VARCHAR, \"extension\" VARCHAR, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"path\" VARCHAR, \"seo\" TEXT DEFAULT '{}', \"stem\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  }
}
export const gitInfo = {
  "name": "forgd",
  "owner": "forged-com",
  "url": "https://github.com/forged-com/forgd"
}
export const appConfigSchema = {}